import React from 'react';
import { getImgixUrl } from '../../../../helpers';
import { withTranslation } from 'react-i18next';
import { withBrand } from '../../../../providers/BrandProvider';
import PropTypes from 'prop-types';

const PersonContentCarouselArrow = (props) => {
  const {
    className,
    style,
    onClick,
    currentSlide,
    slideCount,
    slides,
    tenantId,
    t,
    isPrevSlide,
  } = props;

  const prevSlidePos = currentSlide === 0 ? slideCount - 1 : currentSlide - 1;
  const nextSlidePos = currentSlide !== slideCount - 1 ? currentSlide + 1 : 0;
  const slidePos = isPrevSlide ? prevSlidePos : nextSlidePos;
  const prevSlidePhoto = slides[slidePos].photo || {};

  const backgroundImagePath = getImgixUrl(
    tenantId,
    prevSlidePhoto.path,
    'fit=clamp&w=62&h=62',
    '/images/default-silhouette.png',
  );

  return (
    <div
      className={className}
      style={{ ...style, backgroundImage: `url(${backgroundImagePath})` }}
      onClick={onClick}
      data-testid={
        isPrevSlide
          ? 'personal-content-carousel-prev-arrow'
          : 'personal-content-carousel-next-arrow'
      }
    >
      <div className="arrow-text">
        {t(`${isPrevSlide ? 'site.carousel.prev' : 'site.carousel.next'}`)}
      </div>
    </div>
  );
};

PersonContentCarouselArrow.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
  currentSlide: PropTypes.number,
  slideCount: PropTypes.number,
  slides: PropTypes.array,
  isPrevSlide: PropTypes.bool,
};

export default withTranslation()(withBrand(PersonContentCarouselArrow));
